import React from 'react';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter } from 'react-router-dom';
import { SkeletonTheme } from 'react-loading-skeleton-2';

import Routes from './routes';
import GlobalStyle from './styles/global';

import AppProvider from './hooks';
import { MonitorProvider } from './hooks/monitor';

import { defaultTheme } from './styles/theme';

import 'react-responsive-carousel/lib/styles/carousel.min.css';

localStorage.debug = 'socket.io-client:socket';

const App: React.FC = () => (
  <BrowserRouter>
    <ThemeProvider theme={defaultTheme}>
      <AppProvider>
        <MonitorProvider>
          <SkeletonTheme>
            <Routes />
          </SkeletonTheme>
        </MonitorProvider>
      </AppProvider>
      <GlobalStyle />
    </ThemeProvider>
  </BrowserRouter>
);

export default App;
